import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=06ba72d9&scoped=true"
var script = {}
import style0 from "./Schedule.vue?vue&type=style&index=0&id=06ba72d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba72d9",
  null
  
)

export default component.exports